export const VERTEX = /* glsl */ `
  uniform float uTime;
  uniform float uWaveAmplitude;
  uniform float uWaveFrequency;
  varying vec3 vWorldNormal;
  varying vec3 vWorldPosition;
  varying vec2 vUv;
  void main() {
    vUv = uv;
    float wave = sin(position.x * uWaveFrequency + uTime) *
                 cos(position.z * uWaveFrequency + uTime) * uWaveAmplitude;
    vec3 displaced = position + vec3(0.0, wave, 0.0);
    vec4 worldPos = modelMatrix * vec4(displaced, 1.0);
    vWorldPosition = worldPos.xyz;
    vWorldNormal = normalize(mat3(modelMatrix) * normal);
    gl_Position = projectionMatrix * viewMatrix * worldPos;
  }
`;
export const FRAGMENT = /* glsl */ `
  uniform vec3 uDeepColor;
  uniform vec3 uShallowColor;
  uniform float uFresnelPower;
  varying vec3 vWorldNormal;
  varying vec3 vWorldPosition;
  varying vec2 vUv;
  void main() {
    vec3 viewDir = normalize(cameraPosition - vWorldPosition);
    float fresnel = pow(1.0 - max(dot(vWorldNormal, viewDir), 0.0), uFresnelPower);
    gl_FragColor = vec4(mix(uDeepColor, uShallowColor, fresnel), 0.85);
  }
`;
